import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';

/** Server-state cache (research.md §3). Client errors (4xx) are not retried; live data comes over sockets. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failures, error) =>
        !(error instanceof ApiError && error.status >= 400 && error.status < 500) && failures < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});
